import { sort } from 'radash'

import { sortFeatures } from '../sortFeatures.ts'
import {
	GroupAllFeaturesInnerType,
	GroupAllFeaturesResultElement
} from './groupAllFeaturesTypes.ts'

export const transformGroupsInnerToResult = (
	{ ids, groups, features }: GroupAllFeaturesInnerType,
	optionPrioritySort = true
): GroupAllFeaturesResultElement[] => {
	const result: GroupAllFeaturesResultElement[] = []

	ids.forEach(id => {
		result.push({
			id,
			group: groups[id],
			features: sortFeatures(features[id], optionPrioritySort)
		})
	})

	return sort(result, element => element.group.priority ?? -1, true)
}
